import { prop } from 'ramda';
import { useCallback, useMemo } from 'react';
import { useComponentConfig } from 'js/hooks/component';
import { useUserSelector } from 'js/store/hooks';

import { KAMBI_DEFAULT_LOCALE, KAMBI_DEFAULT_LOCALE_MAP } from '../constants';

export const useKambiConfig = () => {
    const currencyCode = useUserSelector(prop('currencyCode'));
    const lang = useUserSelector(prop('lang'));
    const {
        market,
        oddsFormat,
        localeMap = KAMBI_DEFAULT_LOCALE_MAP,
        defaultLocale = KAMBI_DEFAULT_LOCALE
    } = useComponentConfig();

    const getLocale = useCallback(() => localeMap.find((item) => item.portal === lang)?.kambi || defaultLocale, [
        lang,
        localeMap,
        defaultLocale
    ]);

    return useMemo(() => {
        return {
            loginUrl: 'notification',
            currency: currencyCode,
            market,
            locale: getLocale(),
            ...oddsFormat ? { oddsFormat } : {}
        };
    }, [
        market,
        currencyCode,
        oddsFormat,
        getLocale
    ]);
};
